import React from 'react';

import {
  DescriptionList,
  DescriptionItem,
  TypographyListItem,
} from '@gogame/components';
import { useCurrencyFormat, usePercentFormat } from '@gogame/intl-ts';

const RatioItem = ({ platformName, ratio }) => {
  const percentFormatter = usePercentFormat();

  return (
    <TypographyListItem>{`${platformName}: ${percentFormatter(
      ratio
    )}`}</TypographyListItem>
  );
};

const BudgetAndPayoutSection = ({ data }) => {
  const currencyFormatter = useCurrencyFormat();
  const percentFormatter = usePercentFormat();

  return (
    <DescriptionList data={data} disableGutters={true}>
      <DescriptionItem
        label={'Total budget'}
        field={'totalBudgetUsd'}
        value={
          data &&
          `${currencyFormatter(data?.totalBudgetUsd)} (${data?.costModels
            .map(({ name }) => name)
            .join(', ')})`
        }
      />
      <DescriptionItem
        label={'Allocated budget'}
        field={'allocatedBudgetUsd'}
        value={
          data &&
          `${currencyFormatter(data.allocatedBudgetUsd)} (${percentFormatter(
            (data.allocatedBudgetUsd / data.totalBudgetUsd) * 100
          )})`
        }
      />
      <DescriptionItem
        label={'Payout ratios'}
        field={'payoutRatio'}
        type={'typographyList'}
        listType={'bullet'}
        item={RatioItem}
      />
    </DescriptionList>
  );
};

export default BudgetAndPayoutSection;
